import { getLangPath } from './getLangFormat'

type PathObjType = {
  [key: string]: string
}

export const getPath = (type: string, locale: string) => {
  const pathObj: PathObjType = {
    grc: '/hub/grc',
    cmmc: '/hub/cmmc',
    gdpr: '/hub/gdpr',
    hipaa: '/hub/hipaa',
    'soc-2': '/hub/soc-2',
    fedramp: '/hub/fedramp',
    'pci-dss': '/hub/pci-dss',
    'iso-27001': '/hub/iso-27001',
    'nist-800-53': '/hub/nist-800-53',
    cui: '/hub/cui',
  }

  if (locale === 'en-us') {
    return `${pathObj[type as keyof typeof pathObj]}`
  } else {
    return `/${getLangPath(locale)}${pathObj[type as keyof typeof pathObj]}`
  }
}
